import React, { Component } from 'react';
import Sidenavigation from '../layouts/Sidenavigation';
import Topnavigation from '../layouts/Topnavigation';
import Uploadimagecontent from '../sections/Addproduct/Uploadimagecontent';
import Quickbar from '../layouts/Quickbar';

class Uploadlogo extends Component {
    render() {
        return (
            <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
                <Sidenavigation />
                <main className="body-content">
                    <Topnavigation />
                    <Uploadimagecontent/>
                </main>
                <Quickbar />
            </div>
        );
    }
}

export default Uploadlogo;